import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IPermision, UserPermissions } from '../../auth/models/IUser';
import { AuthService } from '../../auth/services/auth.service';
import {
  canHasPermission,
  checkHostOrOtherUserPermission,
} from '../helpers/permission-formate-helper';
import { StorageService } from '../helpers/storage.service';
import { Storagekeys } from '../model/storage';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const storage = inject(StorageService);

  const reDirectTo = storage.getItem(Storagekeys.redirectTo, true);
  const isAuthenticated = authService.isAuthenticatedUser();

  // ✅ Handle permissions asynchronously
  return authService.getAllUserPermissions().pipe(
    map(() => {
      const hasPermission = canHasPermission(
        route.data as IPermision,
        authService.permissionObj
      );
      const isHostOrOtherUser = checkHostOrOtherUserPermission(
        state.url,
        reDirectTo
      );

      if (!isAuthenticated) {
        return router.createUrlTree(['/auth/login']);
      }

      if (hasPermission && isHostOrOtherUser) {
        return true;
      } else {
        return router.createUrlTree(['/tenant/no-permission']);
      }
    }),
    catchError(() => of(router.createUrlTree(['/auth/login'])))
  );
};
